'use client';

import { BaseLineUp2 } from '@/app/components/icons/BaseLineUp2';
import { Button } from '@/app/components/ui/button';
import { cn } from '@/app/utils';

interface SendButtonProps {
  disabled: boolean;
  sending: boolean;
  onClick: () => void;
}

/**
 * 发送按钮组件
 * 处理消息发送操作
 */
export function SendButton({ disabled, sending, onClick }: SendButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant="outline"
      className={cn(
        'h-full min-w-12 rounded-full border-system-white px-4 py-2 text-black',
        'bg-[linear-gradient(66deg,#C0F9F3_0%,#F8E1FB_50%,#FFF7C4_100%)] bg-system-white',
        'active:bg-[linear-gradient(66deg,#C0F9F3_0%,#F8E1FB_50%,#FFF7C4_100%)]',
        'hover:bg-none hover:bg-system-white',
        sending
          ? 'disabled:bg-[linear-gradient(66deg,#C0F9F3_0%,#F8E1FB_50%,#FFF7C4_100%)] disabled:bg-system-white disabled:opacity-100'
          : 'disabled:border-system-white12 disabled:bg-none disabled:bg-system-white04 disabled:text-system-white24 disabled:opacity-100',
      )}
    >
      {sending ? <div className="size-2.5 rounded-[3px] bg-system-black" /> : <BaseLineUp2 className="size-4" />}
    </Button>
  );
}
